module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-smartscreen",
    style: (_vm.computedStyle)
  }, [_c('div', {
    staticClass: "do-smartscreen__header"
  }, [_c('div', {
    staticClass: "do-smartscreen__header__left"
  }, [_c('h4', [_vm._v(_vm._s(_vm.dateFormatted))])]), _vm._v(" "), _c('div', {
    staticClass: "do-smartscreen__header__right"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("\n        Senest opdateret: " + _vm._s(_vm.latestUpdate) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "d-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.eventsWithProps.length === 0) ? _c('tr', [_c('th', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen lektioner")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.eventsWithProps), function(event) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(event.vEventTime) + " " + _vm._s(event.title))]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(event.vRooms) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(event.vTeachers) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.vStudents))])])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Tidspunkt")]), _vm._v(" "), _c('th', [_vm._v("Lokale")]), _vm._v(" "), _c('th', [_vm._v("Lærer")]), _vm._v(" "), _c('th', [_vm._v("Elever")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2279ff9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Desktop/SmartScreen.vue
// module id = 1801
// module chunks = 1